// extracted by mini-css-extract-plugin
module.exports = {"TabSwriper2":"TabSwriper2_TabSwriper2__tkK3f"};